import { Button } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { DownloadIcon } from 'BreetAssets';
import { ImageComponent } from 'BreetComponents';
import { downloadQrCode, type IDiaryQrCodePositionType } from 'BreetHelpers';
import { useModalApi, useQRCode } from 'BreetHooks';
import { useCallback } from 'react';

export const DialogQrCode = () => {
	const { getModalProps } = useModalApi();

	const { metadata } = getModalProps('qrCode') as {
		metadata?: { url?: string; download?: boolean; position?: IDiaryQrCodePositionType };
	};

	const { qrCode } = useQRCode({ address: metadata?.url });

	const handleDownload = useCallback(() => downloadQrCode(qrCode), [qrCode]);

	return (
		<div className={classNameMerger('qr-code-modal bg-primary-500', metadata?.position)}>
			<ImageComponent
				src={qrCode}
				alt='QR Code'
				className='theme-border-none'
			/>
			{metadata?.download && (
				<Button
					trailingIcon={<DownloadIcon variant='outline' />}
					className='border-dark-navy'
					onClick={handleDownload}
				>
					Download
				</Button>
			)}
		</div>
	);
};
